// Portfolio Administration v1.0 PR 5 — multi-select chip group used by
// the registry list-page filter rows. Each chip toggles a string value
// in/out of the selected set. The state lives in the parent (URL-bound)
// so the chip group is purely presentational.

import { cn } from "@/design-system/lib/utils";

export interface FilterChipOption {
  value: string;
  label: string;
}

export interface FilterChipGroupProps {
  label: string;
  testId: string;
  options: ReadonlyArray<FilterChipOption>;
  selected: ReadonlyArray<string>;
  onChange: (next: string[]) => void;
}

export function FilterChipGroup({
  label,
  testId,
  options,
  selected,
  onChange,
}: FilterChipGroupProps) {
  const toggle = (value: string) => {
    const set = new Set(selected);
    if (set.has(value)) set.delete(value);
    else set.add(value);
    onChange(Array.from(set));
  };
  return (
    <div className="flex flex-col gap-space-1" data-testid={testId}>
      <span className="text-[10px] uppercase tracking-[0.16em] text-gray-mid font-display font-bold">
        {label}
      </span>
      <div className="flex flex-wrap gap-space-1">
        {options.map((opt) => {
          const active = selected.includes(opt.value);
          return (
            <button
              key={opt.value}
              type="button"
              aria-pressed={active}
              data-testid={`${testId}-chip-${opt.value}`}
              onClick={() => toggle(opt.value)}
              className={cn(
                "px-space-2 py-[4px] rounded-sm text-small border transition-colors",
                active
                  ? "bg-gold-shadow text-white-pure border-gold-shadow"
                  : "bg-white-pure text-onyx border-border-light hover:bg-gold-highlight/10",
              )}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
